import { render, staticRenderFns } from "./GreenCoffeeBulkImportSuccessDialog.vue?vue&type=template&id=f473db9e&scoped=true"
import script from "./GreenCoffeeBulkImportSuccessDialog.vue?vue&type=script&lang=js"
export * from "./GreenCoffeeBulkImportSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./GreenCoffeeBulkImportSuccessDialog.vue?vue&type=style&index=0&id=f473db9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f473db9e",
  null
  
)

export default component.exports